import Constants from "common/constant";
import i18n from "features/shared/i18n";
import { ParentPiece } from "features/player/types";

// 公開状態は色と文言の両方で出す（色だけだと伝わらない）
const statusChip = (piece: ParentPiece) => {
  if (piece.banned) {
    return { labelKey: "MSG_PARENT_PAGE_PLAYER_PIECE_BLOCKED", className: "bg-red-100" };
  }
  return piece.published
    ? { labelKey: "MSG_PARENT_PAGE_PLAYER_PIECE_PUBLISHED", className: "bg-green-100" }
    : { labelKey: "MSG_PARENT_PAGE_PLAYER_PIECE_UNPUBLISHED", className: "bg-gray2-100" };
};

export const ParentPieceCard = ({
  piece,
  onClick,
}: {
  piece: ParentPiece;
  onClick?: () => void;
}) => {
  const chip = statusChip(piece);

  return (
    <div
      onClick={onClick}
      className={`flex-col-el items-center gap-2 w-[168px] shrink-0 ${
        onClick ? "cursor-pointer" : ""
      }`}
    >
      <div className="flex-col-el relative w-[168px] h-[120px] rounded-[12px] overflow-hidden border-2 border-solid border-gray2-30 bg-gray2-20 box-border">
        {piece.capture ? (
          <img
            alt={piece.name}
            src={piece.capture}
            className="w-full h-full object-cover"
            onError={(e) => {
              (e.target as HTMLImageElement).src =
                `${Constants.assetHost}/assets/images/default_capture.png`;
            }}
          />
        ) : (
          <div className="flex-col-center w-full h-full text-gray2-100">
            <span className="material-symbols-outlined text-[45px]">extension</span>
          </div>
        )}

        <div
          className={`flex-row-el items-center absolute top-1 left-1 px-2 rounded-full ${chip.className}`}
        >
          <span className="text-[15px] text-white">{i18n.t(chip.labelKey)}</span>
        </div>
      </div>

      <p className="text-body text-center text-body-ellipsis text-[21px] leading-6 text-textcolor-black w-full">
        {piece.name}
      </p>

      {/* 数字は種類ごとに色を分ける（全部同じ色だと何の数字か読み取れない） */}
      <div className="flex-row-center w-full gap-3">
        <div className="flex-row-el items-center gap-1 text-green-100">
          <span className="material-symbols-outlined text-[21px]">play_arrow</span>
          <span className="text-[18px]">{piece.played}</span>
        </div>
        <div className="flex-row-el items-center gap-1 text-red-100">
          <span className="material-symbols-outlined text-[21px]">favorite</span>
          <span className="text-[18px]">{piece.liked}</span>
        </div>
        <div className="flex-row-el items-center gap-1 text-blue-100">
          <span className="material-symbols-outlined text-[21px]">chat_bubble</span>
          <span className="text-[18px]">{piece.commented}</span>
        </div>
      </div>
    </div>
  );
};
